import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ramadan20-league-of-legends',
  templateUrl: './ramadan20-league-of-legends.component.html',
  styleUrls: ['./ramadan20-league-of-legends.component.css']
})
export class Ramadan20LeagueOfLegendsComponent implements OnInit {

  gameName = "league-of-legends";
  constructor() { }

  ngOnInit() {
  }

}
